export default __webpack_public_path__ + "static/apparel-863d060c462d93322dec30b7f75bf4c9.webp";